/**
 * Play background videos only while they are on or near the screen. They ship
 * with `preload="none"` instead of `autoplay`, so a video further down the
 * page, or hidden at the current breakpoint, is never downloaded.
 *
 * Starting a viewport early means the poster gives way to the video before it
 * scrolls into view, rather than flashing over to it in front of the visitor.
 */
export function autoplayVideos() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) {
          target.pause();

          return;
        }

        // Rejects when autoplay is blocked (iOS Low Power Mode) or pause()
        // interrupts loading; the poster stays up either way.
        target.play().catch(() => {});
      });
    },
    { rootMargin: '100% 0px' },
  );

  document.querySelectorAll('video[data-autoplay]').forEach((video) => observer.observe(video));
}
